import React from 'react';
import './Cards.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';

const stockColors = {
  'En stock ': '#10b981',
  'En arrivage': '#6366f1',
  'Sur commande': '#3b82f6',
  'Hors stock': '#ef4444',
};

const mediaVariants = {
  rest: { y: 0, boxShadow: '0 0px 0px rgba(43, 36, 32, 0)' },
  hover: { y: -6, boxShadow: '0 26px 44px -18px rgba(43, 36, 32, 0.45)' },
};

const imageVariants = {
  rest: { scale: 1 },
  hover: { scale: 1.07 },
};

const tagVariants = {
  rest: { rotate: -7, scale: 1 },
  hover: { rotate: 0, scale: 1.06 },
};

const ctaVariants = {
  rest: { x: 0 },
  hover: { x: 4 },
};

const Cards = ({ disponibilité, id, nom, image, titre, reference, prix1 }) => {
  const stockColor = stockColors[disponibilité] || '#6b7280';

  return (
    <motion.div
      className="col-lg-3 col-md-4 col-6 mb-4"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <Link className="hd-card2-link" to={`/${nom}/details/${id}`}>
        <motion.div className="hd-card2" initial="rest" whileHover="hover" animate="rest">
          <motion.div className="hd-card2-media" variants={mediaVariants} transition={{ duration: 0.35, ease: 'easeOut' }}>
            <motion.img
              src={image}
              alt={titre}
              className="hd-card2-image"
              variants={imageVariants}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            />

            {disponibilité && (
              <span className="hd-card2-stock">
                <span className="hd-card2-stock-dot" style={{ backgroundColor: stockColor }} />
                {disponibilité.trim()}
              </span>
            )}

            <motion.span
              className="hd-card2-tag"
              variants={tagVariants}
              transition={{ type: 'spring', stiffness: 320, damping: 16 }}
            >
              {prix1} DT
            </motion.span>
          </motion.div>

          <div className="hd-card2-info">
            {reference && <span className="hd-card2-ref">Réf. {reference}</span>}
            <h3 className="hd-card2-title">{titre}</h3>

            <motion.span
              className="hd-card2-link-text"
              variants={ctaVariants}
              transition={{ type: 'spring', stiffness: 380, damping: 20 }}
            >
              Découvrir
              <FiArrowRight />
            </motion.span>
          </div>
        </motion.div>
      </Link>
    </motion.div>
  );
};

export default Cards;
